import { render, staticRenderFns } from "./form.vue?vue&type=template&id=fd23a12a&scoped=true"
import script from "./form.js?vue&type=script&lang=js&external"
export * from "./form.js?vue&type=script&lang=js&external"
import style0 from "./form.vue?vue&type=style&index=0&id=fd23a12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd23a12a",
  null
  
)

export default component.exports